import Vue from 'vue'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'


import SuiVue from 'semantic-ui-vue';
import 'semantic-ui-css/semantic.min.css';

import App from './App.vue'
import router from './router'
import store from './store'

import awsconfig from './aws-exports'
Amplify.configure(awsconfig)

Vue.config.productionTip = false



Vue.use(SuiVue);
Vue.use(require('vue-moment'));
Vue.use(AmplifyPlugin, AmplifyModules)




new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')


